/**
 * A short list of social network names – mostly exists because for some
 * reason "mail" has been named "share" in the API.
 */
export var socialNetworkNameReplacement = {
  facebook: 'facebook',
  twitter: 'twitter',
  whatsapp: 'whatsapp',
  share: 'mail'
};